// This could be perfect for the modal split chart...
// x: year
// y: some value
export const CHART_DATA = [
  {
    "id": "BAU",
    "color": "#BEBEBE",
    "data": [
      {
        "x": 2018,
        "y": 100
      },
      {
        "x": 2020,
        "y": 123
      },
      {
        "x": 2022,
        "y": 150
      },
      {
        "x": 2024,
        "y": 180
      },
      {
        "x": 2026,
        "y": 34
      },
      {
        "x": 2028,
        "y": 95
      },
      {
        "x": 2030,
        "y": 114
      },
      {
        "x": 2032,
        "y": 58
      },
      {
        "x": 2034,
        "y": 45
      },
      {
        "x": 2036,
        "y": 208
      }
    ]
  },
  {
    "id": "Scenario 2",
    "color": "#588BE5",
    "data": [
      {
        "x": 2018,
        "y": 226
      },
      {
        "x": 2020,
        "y": 207
      },
      {
        "x": 2022,
        "y": 172
      },
      {
        "x": 2024,
        "y": 18
      },
      {
        "x": 2026,
        "y": 153
      },
      {
        "x": 2028,
        "y": 170
      },
      {
        "x": 2030,
        "y": 123
      },
      {
        "x": 2032,
        "y": 109
      },
      {
        "x": 2034,
        "y": 100
      },
      {
        "x": 2036,
        "y": 259
      }
    ]
  },
  {
    "id": "Scenario 1",
    "color": "#BD544A",
    "data": [
      {
        "x": 2018,
        "y": 40
      },
      {
        "x": 2020,
        "y": 166
      },
      {
        "x": 2022,
        "y": 176
      },
      {
        "x": 2024,
        "y": 222
      },
      {
        "x": 2026,
        "y": 103
      },
      {
        "x": 2028,
        "y": 47
      },
      {
        "x": 2030,
        "y": 95
      },
      {
        "x": 2032,
        "y": 267
      },
      {
        "x": 2034,
        "y": 24
      },
      {
        "x": 2036,
        "y": 241
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/data/sample-chart-data-2.js